import Modal from 'bootstrap/js/dist/modal'

let accountModal: Modal | null = null

function submitForm() {
  const leadForm = document.querySelector<HTMLFormElement>('#lead-form')
  if (leadForm) {
    leadForm.submit()
  }
}

function maybeSave() {
  const leadStatusEl =
    document.querySelector<HTMLSelectElement>('#id_lead-status')
  if (leadStatusEl && leadStatusEl.value === 'account') {
    if (accountModal) {
      accountModal.show()
    }
  } else {
    submitForm()
  }
}

function initAgencyLeadEdit() {
  const accountModalEl = document.querySelector<HTMLElement>('#accountModal')
  if (accountModalEl) {
    accountModal = new Modal(accountModalEl, {})
  }

  const cardFooterSubmitBtn = document.querySelector<HTMLButtonElement>(
    '#card-footer-submit',
  )
  if (cardFooterSubmitBtn) {
    cardFooterSubmitBtn.onclick = () => {
      maybeSave()
    }
  }

  const modalFooterSubmitBtn = document.querySelector<HTMLButtonElement>(
    '#modal-footer-submit',
  )
  if (modalFooterSubmitBtn) {
    modalFooterSubmitBtn.onclick = () => {
      modalFooterSubmitBtn.disabled = true
      submitForm()
    }
  }
}

export { initAgencyLeadEdit }
